// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__hxO4L","background":"Modal_background__KRkPs","body":"Modal_body__FmyCY","close":"Modal_close__fCd7-","open":"Modal_open__Y93-C"};